// Making a new JS component
// 1 - Replace magazineLoader with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var magazineLoader = {
	name: 'magazineLoader',
	componentInitSelector: '.magazine-loader',
	registerComponent: function() {
		if ( $(magazineLoader.componentInitSelector).length ) {
			framework.registerComponent(magazineLoader);
		}
	},
	initmagazineLoader: function() {
        // Put your args and inits here with their options.

        // End
        log(config.application.name + " •• magazineLoader in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
	init: function() {
		// All code for this component goes in here
		var initShow = 12; //number of items loaded on init & onclick load more button
		var counter = 6; 

		// init Isotope
		var $grid = $('.grid').isotope({
			itemSelector: '.filteredItem'
		});

		var iso = $grid.data('isotope');

		function loadMore(toShow) {
			$grid.find(".hidden").removeClass("hidden");

			var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
				return item.element;
			});
			
			$(hiddenElems).addClass('hidden');
			$grid.isotope('layout');

			//when no more to load, hide show more button
			if (hiddenElems.length == 0) {
				$(".load-more").hide();
			} else {
				$(".load-more").show();
			};
		}

		loadMore(initShow);

		//when load more button clicked
		$(".load-more").click(function() {
			counter = counter;

			counter = counter + initShow;

			loadMore(counter);
		});

		// Sometimes layout is screwy so redo it just in case
		$( window ).load(function() {
			$('.grid').isotope('layout', function(){});
		});
		
        $( document ).ready(function() {
            $('.grid').isotope('layout', function(){});
        });
        $( window ).resize(function() {
        	setTimeout(function(){
                $('.grid').isotope('layout', function(){});
			}, 1000);

        });

		// End
		magazineLoader.initmagazineLoader();
	}
}

// Register self to the framework
magazineLoader.registerComponent();